import React from 'react';
import { cx } from '../cx';

// D-09 §15.5 — Badge (.badge + soft/outline · badge-<status>) — 채움(포인트색) 표시는 variant 가 아니라 status="accent"(v2.24, solid 폐지)
// status 6종 (D-09 §15.5): 글자 {상태}-700 / 배경 {상태}-50 / 테두리 {상태}-200, done·mute=gray(글자 gray-600) — 600 은 50 배경 위 AA 미달
// 크기는 md(badge-height-md) 하나뿐 — sm/lg 없음(D-09 §15.5 v2.21).
// 'error' 는 폐기예정 별칭(=danger). 기존 상태 매핑 코드 하위호환용 — 신규는 'danger' 사용.
// 'accent' = 포인트색(--gt-primary 채움 · --gt-on-primary 글자) — 추천·강조 표시용. 상태 의미 없음.
export type BadgeStatus = 'success' | 'info' | 'warning' | 'danger' | 'done' | 'mute' | 'accent';
export interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  variant?: 'soft' | 'outline';
  status?: BadgeStatus | 'error';
}

export function Badge({ variant, status, className = '', children, ...props }: BadgeProps) {
  const st: BadgeStatus | undefined = status === 'error' ? 'danger' : status;
  return (
    <span
      className={cx('badge', variant ?? '', st && `badge-${st}`, className)}
      {...props}
    >
      {children}
    </span>
  );
}
